const OPEN_STARTUP_PROFILE_KEY = 'prairi.openStartupProfile';

export type RememberedStartupProfile = {
  slug: string;
  userId: string;
};

export function rememberOpenStartupProfile(profile: RememberedStartupProfile): void {
  if (!profile.slug || !profile.userId) return;
  try {
    localStorage.setItem(OPEN_STARTUP_PROFILE_KEY, JSON.stringify(profile));
  } catch {
    // Storage can be blocked. The open URL still works for this visit.
  }
}

export function readOpenStartupProfile(): RememberedStartupProfile | null {
  try {
    const raw = localStorage.getItem(OPEN_STARTUP_PROFILE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<RememberedStartupProfile>;
    if (!parsed.slug || !parsed.userId) return null;
    return { slug: parsed.slug, userId: parsed.userId };
  } catch {
    return null;
  }
}

export function forgetOpenStartupProfile(): void {
  try {
    localStorage.removeItem(OPEN_STARTUP_PROFILE_KEY);
  } catch {
    // Ignore storage failures.
  }
}

/** My Dashboard always opens the catalog, never a remembered profile. */
export function dashboardReturnPath(_pathname: string, _rememberedSlug: string | null): string {
  return '/dashboard';
}
